import { FeatureFlag } from '../FeatureFlag';
import { z } from 'zod';

// Zod schema for subPagesConfig
export const AdminRiskSubPagesConfigSchema = z.object({
    pages: z.array(
        z.object({
            id: z.string(),
            titleTranslationKey: z.string(),
            properties: z.array(z.string()),
        }),
    ),
});

// TypeScript type derived from the schema
export type AdminRiskSubPagesConfig = z.infer<typeof AdminRiskSubPagesConfigSchema>;

export const adminRiskSubPagesConfig = new FeatureFlag<AdminRiskSubPagesConfig>({
    key: 'admin-risk-sub-pages-config',
    createdOn: '2025-08-26',
    defaultValue: { pages: [] },
});
